import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  homePage: (data) => http.post(`${hr}/pubBenefit/homePage`, data), // 公益首页
  myPubBenefit: (data) => http.post(`${hr}/pubBenefit/myPubBenefit`, data), // 公益信息
  apply: (data) => http.post(`${hr}/pubBenefit/apply`, data), // 公益报名
  cancel: (data) => http.post(`${hr}/pubBenefit/cancel`, data), // 公益取消报名
  detail: (data) => http.post(`${hr}/pubBenefit/detail`, data), // 活动详情
  getSignInCodes: (data) => http.post(`${hr}/pubBenefit/getSignInCodes`, data), // 获取二维码
  getTypeList: (data) => http.post(`${hr}/pubBenefit/getTypeList`, data), // 获取公益分类列表
  signInStatistics: (data) =>
    http.post(`${hr}/pubBenefit/signInStatistics`, data), // 公益活动签到统计
  myAudit: (data) => http.post(`${hr}/pubBenefit/myAudit`, data), // 审批列表
  history: (data) => http.post(`${hr}/pubBenefit/history`, data), // 我的公益历程
  auditDetail: (data) => http.post(`${hr}/pubBenefit/auditDetail`, data), // 公益审批详情
  audit: (data) => http.post(`${hr}/pubBenefit/audit`, data), // 审批通过|驳回
  // 导出
  visitorLogExport: (data) =>
    http.post(`${hr}/pubBenefit/signInStatisticsExport`, data, {
      responseType: "blob",
    }),
  getLastThreeMedals: (data) => http.post(`${hr}/pubBenefit/getLastThreeMedals`, data), // 获得最后三个公益勋章
  // 管理员审核
  adminAudit: (data) => http.post(`${hr}/pubBenefit/adminAudit`, data),
  // 管理员列表
  adminList: (data) => http.post(`${hr}/pubBenefit/adminList`, data),
  // 新增管理员
  adminAdd: (data) => http.post(`${hr}/pubBenefit/adminAdd`, data),
  // 删除管理员
  adminDelete: (data) => http.post(`${hr}/pubBenefit/adminDelete`, data),
  // 是否是管理员
  isAdmin: (data) => http.post(`${hr}/pubBenefit/isAdmin`, data),
  // 获取公益时长
  duration: (data) => http.post(`${hr}/pubBenefit/duration`, data),
};
